class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const drawer = document.querySelector('.drawer');
    drawer.addEventListener('click', (evt) => { if(evt.target.classList.contains('cart-drawer')) { this.close(); } });
    this.setHeaderCartIconAccessibility();
    this.setupCartCta();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  setupCartCta() {
    const cartLink = document.querySelector('.cart-cta');
    if(cartLink) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });

      // Hide cart-cta if footer is in view
      const observer = new IntersectionObserver(entries => {
        const cta = document.querySelector('.cart-cta');
        entries.forEach(entry => {
          const intersecting = entry.isIntersecting
          cta.style.opacity = intersecting ? "0" : "1"
        })
      });

      observer.observe(document.querySelector('.shopify-section-group-footer-group'));
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    // Don't open cart drawer if is mobile quick-add button
    const mediaQuery = window.matchMedia('(min-width: 650px)');
    if(mediaQuery.matches || !this.activeElement.classList.contains('quick-add__submit')) {
      setTimeout(() => {this.classList.add('animate', 'active')});
    }

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden-mobile');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden-mobile');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('cart-drawer-items').classList.contains('is-empty') && this.querySelector('cart-drawer-items').classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if(typeof MainCode != "undefined") {
        if (window.jQuery) {
          csJq = window.jQuery;
        }
        MainCode(csJq)
      }
      if (section.id === 'cart-drawer') {
        const emptyWrapper = document.querySelector('.drawer__inner-empty')
        document.querySelector(`${section.selector} cart-drawer-items`).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], `${section.selector} cart-drawer-items`);
        document.querySelector(`${section.selector} .drawer__footer`).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], `${section.selector} .drawer__footer`);
        if (emptyWrapper) {
          if (this.querySelector('cart-drawer-items').classList.contains('is-empty')) {
            emptyWrapper.style.display = 'block'
          } else {
            emptyWrapper.style.display = 'none'
          }
        }
      } else {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (sectionElement && parsedState.sections[section.id]) {
          sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

          if (section.id === 'cart-icon-bubble') {
            sectionElement.classList.add('pop');

            setTimeout(() => {
                sectionElement.querySelector('.cart-count-bubble').classList.remove('pop');
            }, 200);
            
          }
        }
      }
    }));

    setTimeout(() => {
      if (window.innerWidth >= 768) {
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-cta'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-cta',
        section: 'cart-cta',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
